import React, { useContext } from "react";
import ModalContext from "../../../Contexts/openModal";
import "../../../styles/components/Slices/SectionMonet.scss";
import HeadingSection from "../../Pieces/HeadingSection";
import { Chevron, NextArrow } from "../../../assets/icons";

export const SectionMonet = ({ slice, location }) => {
  const { toggleModal } = useContext(ModalContext);
  const isTopAligned = slice?.primary?.layout_alignment === "top aligned";
  const imageUrl = slice?.primary?.image?.url;
  const isDark = slice?.primary?.theme === "dark";
  const topSpacing = slice?.primary?.top_spacing;
  const bottomSpacing = slice?.primary?.bottom_spacing;
  const Homepage = location?.pathname === "/";

  return (
    <article className={isDark && "bg-purple-2300"}>
      <section className="relative px-4 mx-auto sm:px-12 lg:px-5 max-w-7xl">
        <article
          className={`lg:mx-11 ${topSpacing === "80" ? "sm:pt-20 pt-8" : topSpacing === "40" ? "sm:pt-10 pt-8" : topSpacing === "0" ? "pt-0" : "pt-10 lg:pt-20"}  ${bottomSpacing === "80" ? "sm:pb-20 pb-8" : bottomSpacing === "40" ? "sm:pb-10 pb-8" : bottomSpacing === "0" ? "pb-0" : "pb-10 lg:pb-20"} `}
        >
          <section
            className={`flex flex-col lg:justify-between  lg:gap-10 ${slice?.primary?.reversed ? "md:flex-row-reverse" : "md:flex-row"} ${isTopAligned ? "items-start" : "items-center"}`}
          >
            <div
              className={` ${slice?.items?.length > 0 ? "md:lg:min-w-[380px] lg:min-w-[425px] lg:max-w-[425px]" : "md:max-w-[392px]"} `}
            >
              <HeadingSection
                ctaLink={slice?.primary?.cta_link?.url}
                icon={slice?.items.length > 0 ? <Chevron fill="white" /> : null}
                data={slice?.primary}
                toggleModal={toggleModal}
                sectionStyle={`lg:!pb-0 ${Homepage && "pb-4 sm:pb-6 lg:pb-0 "}`}
                headingStyle={`sm:text-3.25xl !leading-10 -tracking-[0.9px] ${isDark && "text-white dark_strong_style"}`}
                descriptionStyle={`sm:text-base custom_line_height !-tracking-[0.45px] ${isDark && "!text-[#F5F5F5]"} `}
                textAreaStyle="gap-4"
                buttonStyle={`${isDark && "!bg-white mx-0 !text-[#434343] hover:!bg-[#DFDFDF]"} ${slice?.items?.length > 0 && "gap-2"} `}
                target={isDark ? "_blnak" : "_self"}
              />
              {slice?.items?.length > 0 && slice?.items?.stat_icon?.url && (
                <section className="lg:mt-4 gap-1">
                  {slice?.items?.map((val, index) => (
                    <div className="flex items-start gap-[5px]" key={index}>
                      <img
                        src={val?.stat_icon?.url}
                        alt="items icon"
                        className="size-[22px] mt-[1px]"
                      />
                      <div
                        className=" text-gray-600 font-normal strong-stat-text text-base -tracking-[0.9px]"
                        dangerouslySetInnerHTML={{
                          __html: val?.stat_text?.html,
                        }}
                      />
                    </div>
                  ))}
                </section>
              )}
            </div>
            {imageUrl && (
              <div
                className={`items-end hidden max-w-[720px] ${Homepage ? "!pt-4 sm:!pt-0 sm:pb-0" : " lg:py-0"}  sm:-mx-12 lg:-mx-0  sm:block ${slice?.items?.length < 0 && "bg-image-monet lg:pl-16"}`}
              >
                {/* <GatsbyImage
                image={getImage(slice?.primary?.image)}
                alt="Monet"
                className="px-12 lg:px-0"
                fetchPriority="high"
                loading="lazy"
              /> */}
                <img
                  src={slice?.primary?.image?.url}
                  alt="Monet"
                  className="px-12 lg:px-0"
                  loading="lazy"
                />
              </div>
            )}
            {slice?.primary?.mobile_asset?.url && (
              <div
                className={` items-end block -mx-4 ${Homepage ? "!pt-4 sm:!pt-0 sm:pb-0" : "sm:py-10"} sm:hidden ${slice?.items?.length < 0 && "bg-image-monet"}`}
              >
                {/* <GatsbyImage
                image={getImage(slice?.primary?.mobile_asset)}
                // src={slice?.primary?.mobile_asset?.url}
                alt="mobile_asset"
                className="px-4"
                fetchPriority="high"
                loading="lazy"
              /> */}
                <img
                  src={slice?.primary?.mobile_asset?.url}
                  alt="mobile_asset"
                  className="px-4"
                  loading="lazy"
                />
              </div>
            )}
          </section>
        </article>
      </section>
    </article>
  );
};
